const IMAGE_REGULAR_SIZE = {
  mobile: {
    width: 272,
    height: 224,
  },
  tablet: {
    width: 272,
    height: 236,
  },
  desktop: {
    height: 236,
    width: 420,
  },
}

const CONTENT_REGULAR_GUTTER = {
  top: 'double',
  left: 'double',
  right: 'double',
  bottom: 'double',
}

const DESCRIPTION_COLLAPSABLE_LENGTH = 70
const DESCRIPTION_MAX_LENGTH = 180

const PUBLICATION_TYPE_STANDARD = 'STANDARD'

const UNIT_TYPES_DATAZAP_APPROVED = ['APARTMENT', 'HOME', 'CONDOMINIUM', 'VILLAGE_HOUSE']

export {
  IMAGE_REGULAR_SIZE,
  PUBLICATION_TYPE_STANDARD,
  CONTENT_REGULAR_GUTTER,
  DESCRIPTION_COLLAPSABLE_LENGTH,
  DESCRIPTION_MAX_LENGTH,
  UNIT_TYPES_DATAZAP_APPROVED,
}
